module.exports = __webpack_public_path__ + "acb7f7cb89a3d98ca4d3368c66fd86a9.pdf";